import { createTheme, styled } from '@mui/material/styles';
import {
  Badge,
  Box,
  Grid,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import { withStyles } from '@mui/styles';

export const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#c1c1c1',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

export const UserSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: '12px',
}));

export const UserInfoSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: '5px',
  flexWrap: 'wrap',
}));

export const NameText = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  color: '#ffffff',
  fontWeight: 'bold',
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#36899f',
    color: '#36899f',
    '&::after': {
      position: 'relative',
      width: '150%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

export const CustomMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    padding: '1rem',
    borderRadius: '30px',
    background: '#3b394e',
    color: '#c1c1c1',
  },
}));

export const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  // padding: "1rem",
  // borderRadius: "30px",
  margin: '.5rem 0rem',
}));

export const ContentGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  // paddingLeft: "38px",
  // paddingRight: "38px",
}));

export const ParaTextDivGrid = styled(ContentGrid)(({ theme }) => ({
  justifyContent: 'space-between',
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '14px',
  fontWeight: 'bold',
}));

export const ParaText = styled(TitleText)(({ theme }) => ({
  fontSize: '18px',
}));

export const NavLinkRow = styled(Stack)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('lg')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
    display: 'flex',
  },
}));

export const NavLinkTypography = withStyles({
  root: {
    color: '#ffffff',
    fontSize: '1.1rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
})(Typography);
